import React from "react";
import { Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const generateFilter = (placeholder, dataIndex, filterFunction) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        id={`${dataIndex}-searchInput`}
        placeholder={`Buscar ${placeholder}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
      <Space>
        <Button
          onClick={() => clearFilters()}
          size="small"
          style={{ width: 90, height: "2rem" }}
        >
          Restablecer
        </Button>
        <Button
          type="primary"
          onClick={() => confirm()}
          size="small"
          style={{ width: 90, height: "2rem" }}
        >
          Buscar
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
  ),
  onFilter: filterFunction,
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(
        () => document.getElementById(`${dataIndex}-searchInput`).select(),
        100
      );
    }
  },
});

export default generateFilter;



// WEBPACK FOOTER //
// ./src/utils/generateFilter.js